import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const YearValidator = function (
  control: AbstractControl,
): ValidationErrors | null {
  const year = Number(control.value);
  const currentYear = new Date().getFullYear();
  if (control.value && (isNaN(year) || year < 1900 || year > currentYear + 1)) {
    return { custom: `Please enter a valid year` };
  }
  return null;
};

export const VINValidator = function (
  control: AbstractControl,
): ValidationErrors | null {
  const vinRegex = /^[A-HJ-NPR-Z0-9]{17}$/i;
  if (control.value && !vinRegex.test(control.value)) {
    return { custom: `Please enter correct VIN number` };
  }
  return null;
};

export const HEXValidator = function (
  control: AbstractControl,
): ValidationErrors | null {
  const hexColorRegex = /^#([0-9A-Fa-f]{3}){1,2}$/;
  if (control.value && !hexColorRegex.test(control.value)) {
    return { custom: `Invalid hexadecimal color (#xxxxxx)` };
  }
  return null;
};

export const USAPhoneNumberValidator = function (
  control: AbstractControl,
): ValidationErrors | null {
  const USPhoneNumberPattern =
    /^(\+?1\s?)?(\(\d{3}\)|\d{3})[- ]?\d{3}[- ]?\d{4}$/;
  if (!control.value) {
    return null;
  }
  if (!USPhoneNumberPattern.test(control.value)) {
    return { custom: 'Please enter valid phone number' };
  }
  return null;
};

export const IdRequiredValidator = (
  control: AbstractControl,
): ValidationErrors | null => {
  if (!control.value) {
    return null;
  }
  const value = control.value;
  if (
    value &&
    typeof value === 'object' &&
    value.hasOwnProperty('id') &&
    value?.id
  ) {
    return null; // valid
  }
  return { objectWithIdRequired: true };
};

export const TwoDecimalValidator = (
  control: AbstractControl,
): ValidationErrors | null => {
  if (!control.value) {
    return null;
  }

  const value = control.value;
  const splitSymbol = value?.includes(',') ? ',' : '.';
  const parts = value.split(splitSymbol);

  // Validate integer part
  const integerPart = parts[0];
  if (integerPart && isNaN(Number(integerPart))) {
    return { custom: 'Only numeric values are allowed' };
  }

  // Validate decimal part
  if (parts.length > 2) {
    return { custom: 'Only one decimal point is allowed' };
  }

  const decimalPart = parts[1];
  if (decimalPart && decimalPart.length > 2) {
    return { custom: 'Only two decimal digits are allowed' };
  }

  return null;
};

export const RequiredExceptZero = (
  control: AbstractControl,
): ValidationErrors | null => {
  const value = control.value;
  if (value === 0) {
    return null;
  }
  if (!value) {
    return { required: true };
  }
  return null;
};

export function FileSizeValidator(maxSize: number): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const files: File[] = control.value;
    if (files && files.length > 0) {
      for (let file of files) {
        if (file.size > maxSize) {
          return { fileSize: true };
        }
      }
    }
    return null;
  };
}


export function minItemsValidator(min: number, propName: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const formArray = control as any;
    const checkedControls = formArray?.value?.filter((v: any) => v[propName]);
    if (checkedControls?.length >= min) {
      return null; // Valid if there are at least `min` items
    }
    return { minItems: { requiredItems: min, actualItems: formArray?.controls?.length || 0 } };
  };
}
